/**
 * Parses a snapshot `reportDate` (YYYY-MM-DD) as a local calendar date.
 * `new Date('YYYY-MM-DD')` is parsed as UTC midnight and renders a day early in timezones behind UTC.
 */
export const parseReportDate = (dateStr: string): Date => {
  const [year, month, day] = dateStr.split('T')[0].split('-').map(Number);
  return new Date(year, month - 1, day);
};
